'use strict';

var moment = require('moment');
var isNil = require('lodash/isNil');

var ValidationSuccess = require('./models/validation-success');
var ValidationFailure = require('./models/validation-failure');

module.exports = function (value) {
  if (!isNil(value.end) && moment(value.start).isAfter(value.end)) {
    return new ValidationFailure('"To" date must be after "From" date');
  }

  if (!isNil(value.end) && !isNil(value.start.year) && value.start.year === value.end.year && (isNil(value.start.month) || isNil(value.end.month))) {
    return new ValidationFailure('Months must be provided if "From" and "To" years are the same');
  }

  return new ValidationSuccess();
};